import { organizationQueries } from '@/lib/services/organizations/organizations.query'
import { canViewMoney } from '@/lib/services/money/money.access'
import { createFileRoute, notFound, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/$orgId/money')({
  beforeLoad: async ({ context, params }) => {
    const organization = await context.queryClient.ensureQueryData(
      organizationQueries.show(params.orgId)
    )
    if (
      +params.orgId === +import.meta.env.VITE_TUKIOS_FLOWERS_ORG_ID ||
      !canViewMoney(context.ability, { organization })
    )
      throw notFound()
  },
  component: Outlet,
})
